import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Dot } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[200]}`,
    display: 'block',
    padding: theme.spacing(2),
    borderSpacing: '5px',
    borderCollapse: 'separate'
  },
  th: { textAlign: 'center' },
  left: { textAlign: 'left' },
  right: { textAlign: 'right' }
}));

interface CustomTooltipProps {
  payload?: {
    name: string
    value: string
    color: string
  }[]
  label?: string
  formatter?: (value: string) => string
  labelFormatter?: (label?: string) => string
}

export default function CustomTooltip ({ payload = [], label = '', labelFormatter = () => '', formatter }: CustomTooltipProps) {
  const classes = useStyles();

  return (
    <table className={classes.root}>
      <thead>
        <tr>
          <th className={classes.th} colSpan={3}>{labelFormatter(label)}</th>
        </tr>
      </thead>
      <tbody>
        {payload.map(({ name, value, color }) => {
          return (
            <tr key={name}>
              <td className={classes.left}>
                <Dot size='sm' color={color} />
              </td>
              <td className={classes.left}>
                {name}
              </td>
              <td className={classes.right}>
                {formatter ? formatter(value) : value}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
